import { useEffect } from "react";
import { TableActions } from "../../components/tables/tableContext/TableContext";
import {} from "../../components/tables/tableHelper";
import TableWidget from "../../components/tables/TableWidget";
import useRoutesHelper from "../../hooks/useRoutesHelper";
import { getReceiptsDataList } from "../../redux/api/receipt.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  clearAvailableReceiptsList,
  clearProductDetails,
  clearReceiptDetails,
} from "../../redux/reducer/receipt.reducer";
import ReceivedProductsTableAction from "./components/TableActionsButtonsComponents/ReceivedProductsTableAction";
import {
  receiptDetailsTableHeader,
  receivedProductsTableConfig,
} from "./components/tableConfigs/receivedProductsTableConfig";

function ReceivedProducts() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();
  const receptionId = routeParams?.reception;
  const receivedAt = routeParams?.data;

  const {
    receipt: {
      receiptDetails: {
        data: {
          products: { data: productsData, total: productsTotal },
          furnizor,
          status,
        },
        isLoadingReceiptData,
      },
    },
  } = useAppSelector((state) => ({
    receipt: state.receipt,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      receptionId &&
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        getReceiptsDataList({
          idFlux: receptionId,
          per_page: 9999,
          codProdusErp: action.tableSearch?.codProdusErp,
          numeProdusErp: action.tableSearch?.numeProdusErp,
          sn: action.tableSearch?.sn,
          lot: action.tableSearch?.lot,
        }),
      );
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearAvailableReceiptsList());
      dispatch(clearProductDetails());
      dispatch(clearReceiptDetails());
    };
  }, [dispatch]);

  const getPageTitle = () => {
    if (isLoadingReceiptData) {
      return "Se încarcă datele...";
    }
    return `Produse receptionate de la ${furnizor} in data ${receivedAt}`;
  };

  return (
    <TableWidget
      tableTitle={getPageTitle()}
      tableHeaderData={receiptDetailsTableHeader}
      tableItemsData={receivedProductsTableConfig(productsData)}
      totalItems={productsTotal}
      ActionButtonsComponent={(props: any) => (
        <ReceivedProductsTableAction
          {...props}
          status={status}
          receptionId={receptionId}
        />
      )}
      handleTableActions={handleTableActions}
      borderedRow
      withTablePagination={false}
    />
  );
}

export default ReceivedProducts;
